import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import GestionDescuentos from './GestionDescuentos'; // Este componente maneja la adición y edición
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

function Descuentos() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const { user } = useUser();
    
    const [descuentos, setDescuentos] = useState([]);
    const [editingDescuento, setEditingDescuento] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [descuentoToDelete, setDescuentoToDelete] = useState(null);

    // Función para cargar los descuentos
    const fetchDescuentos = async () => {
        try {
            const response = await fetch(`${server}/MgTarjetasDescuentoes`);
            const data = await response.json();
            setDescuentos(data.$values);
            console.log(data.$values);
        } catch (error) {
            console.error('Error al cargar los descuentos:', error);
        }
    };

    // Use effect para cargar los descuentos al montar el componente
    useEffect(() => {
        fetchDescuentos();
    }, []);

    // Actualiza la lista de descuentos tras una modificación
    const handleNewDescuento = () => {
        fetchDescuentos();
        setEditingDescuento(null);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleOpenDialog = (descuento) => {
        setDescuentoToDelete(descuento);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setDescuentoToDelete(null);
    };

    const handleDeleteDescuento = async () => {
        if (descuentoToDelete) {
            try {
                const usuarioBase = user?.codigoUsuario || 'ADMIN';
                const usuario = usuarioBase.padEnd(20, ' ');
                const usuarioEncoded = encodeURIComponent(usuario);
                
                const response = await fetch(`${server}/MgTarjetasDescuentoes/${descuentoToDelete.id}/${usuarioEncoded}`, {
                    method: 'DELETE'
                });
                if (response.ok) {
                    handleCloseDialog();
                    fetchDescuentos();
                    alert('Descuento eliminado con éxito');
                } else {
                    alert('Error al eliminar el descuento');
                }
            } catch (error) {
                console.error('Error al eliminar el descuento:', error);
                alert('Error al eliminar el descuento');
            }
        }
    };

    const filteredDescuentos = descuentos.filter(descuento => descuento.descripcionTarjeta?.toLowerCase().includes(searchQuery.toLowerCase()));

    return (
        <>
            <div className="x_title"></div>
            <div className="x_content">
                <br />
                <GestionDescuentos descuento={editingDescuento} onDescuentoGuardado={handleNewDescuento} />
                <div className="ln_solid" />

                <h2>Descuentos Existentes</h2>
                <div className="row">
                    <div className="col-md-7 col-sm-4 offset-md-2">
                        <TextField
                            variant="outlined"
                            label="Buscar descuento"
                            fullWidth
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />
                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                        <TableCell align="right">Acciones</TableCell>
                                            <TableCell>Descripción</TableCell>
                                            <TableCell>Porcentaje Descuento</TableCell>
                                            <TableCell>Imagen de Descuento</TableCell>
                                            <TableCell>Imagen de Fondo</TableCell>
                                            <TableCell>Imagen de Sello</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredDescuentos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((descuento) => (
                                            <TableRow key={descuento.id}>
                                                <TableCell align="right">
                                                    <Button onClick={() => setEditingDescuento(descuento)} color="primary" disabled={!tienePermiso('Editar Descuento Análisis')}>Editar</Button>
                                                    <Button onClick={() => handleOpenDialog(descuento)} color="secondary" disabled={!tienePermiso('Eliminar Descuento Análisis')}>Eliminar</Button>
                                                </TableCell>
                                                <TableCell>{descuento.descripcionTarjeta}</TableCell>
                                                <TableCell>{descuento.porcentajeDescuento}</TableCell>
                                                <TableCell>{descuento.imagenDescuento}</TableCell>
                                                <TableCell>{descuento.imagenFondo}</TableCell>
                                                <TableCell>{descuento.imagenSello}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={filteredDescuentos.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                                />
                            </TableContainer>
                            <Dialog
                                open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ¿Estás seguro de que deseas eliminar el descuento seleccionado?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                    <Button onClick={handleDeleteDescuento} color="primary" autoFocus>Eliminar</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Descuentos;
